// This file is a port from the `dismissableBanner.jsx` component in the customers codebase.
// We want to leave it as close to the customers counterpart as possible in order to easily
// reflect any changes made there.
// As such, it is not a reflection of the patterns used throughout the retailer-tools codebase

import React from 'react'
import Radium from 'radium'
import { Button } from 'ic-snacks'
import { generateDestinationUrl } from 'domains/merchandising/utils/heroBannerUtils'
import { FormattedText } from './FormattedText'
import styles, { baseContainerStyle } from './styles'
import { type Props } from './types'

@Radium
export class HeroBannerPreview extends React.PureComponent<Props> {
  renderActionButton = () => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { label_action, button_snacks_style, mobile } = this.props

    if (!label_action?.label) return null

    return (
      <Button size={mobile ? 'tiny' : 'standard'} snacksStyle={button_snacks_style as 'primary'}>
        {label_action.label}
      </Button>
    )
  }

  renderImage = () => {
    const { variant } = this.props

    const textVariantStyles = (!variant || variant === 'text') && styles.textVariantImageContainer

    return (
      <img
        src={this.props.banner_image.url}
        css={{ ...styles.imageContainer(this.props.mobile), ...textVariantStyles }}
      />
    )
  }

  renderSubheading = () => (
    <div>
      {this.props.subheading && (
        <h3 css={styles.textSubHeading(this.props.mobile)}>
          <FormattedText {...this.props.subheading} />
        </h3>
      )}
      {this.renderActionButton()}
    </div>
  )

  renderText() {
    const { heading, tag } = this.props
    return (
      <div css={styles.textModule(this.props.mobile)}>
        {tag && (
          <span css={styles.textAnnouncement(this.props.mobile)}>
            <FormattedText {...tag} />
          </span>
        )}
        {heading && (
          <h2 css={styles.textHeading(this.props.mobile)}>
            <FormattedText {...heading} />
          </h2>
        )}
        {this.renderSubheading()}
      </div>
    )
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { label_action, background, variant, retailerConfiguration } = this.props

    const { type, data } = label_action.action
    const destination = generateDestinationUrl(type, data, retailerConfiguration)

    return (
      <a
        href={destination}
        target="_blank"
        rel="noreferrer"
        css={baseContainerStyle(this.props.mobile, background?.color)}
      >
        {(!variant || variant === 'text') && (
          <div css={styles.textContainer(this.props.mobile)}>{this.renderText()}</div>
        )}
        {this.renderImage()}
      </a>
    )
  }
}
